import { render, staticRenderFns } from "./huaquanzhuan.vue?vue&type=template&id=cb1134e0&scoped=true&"
import script from "./huaquanzhuan.vue?vue&type=script&lang=js&"
export * from "./huaquanzhuan.vue?vue&type=script&lang=js&"
import style0 from "./huaquanzhuan.vue?vue&type=style&index=0&id=cb1134e0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1134e0",
  null
  
)

export default component.exports